import { Routes } from '@angular/router';

import { ShellComponent } from './shell/shell.component';
import { AppBlankComponent } from './shell/blank/blank.component';
import { ProfileComponent } from './shell/profile/profile.component';
import { SpeedMonitorComponent, MachineChartComponent } from 'chronos-shared';
import { LiveAuthorizationGuard } from './helpers/live-authorize.guard';

export const appRoutes: Routes = [
  {
    path: '',
    component: ShellComponent,
    canActivate: [LiveAuthorizationGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'configuration',
        loadChildren: () => import('./modules/configuration/configuration.module').then((m) => m.ConfigurationModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'hierarchy-browser',
        loadChildren: () => import('./modules/hierarchy-browser/hierarchy-browser.module').then((m) => m.HierarchyBrowserModule)
      },
      {
        path: 'hierarchy-management',
        loadChildren: () => import('./modules/hierarchy-management/hierarchy-management.module').then((m) => m.HierarchyManagementModule)
      },
      {
        path: 'traceability',
        loadChildren: () => import('./modules/traceability/traceability-main.module').then((m) => m.TraceabilityMainModule)
      },
      {
        path: 'demo',
        loadChildren: () => import('./modules/demo/demo.module').then((m) => m.DemoModule)
      },
      {
        path: 'profile',
        component: ProfileComponent
      },
      {
        path: 'machinechart',
        children: [
          {
            path: '**',
            component: MachineChartComponent
          }
        ]
      },
      {
        path: 'speedmonitor/:externalWorkCenterId',
        component: SpeedMonitorComponent
      }
    ]
  },
  {
    path: 'auth',
    component: AppBlankComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'auth/ad-login'
  }
];
